import { FETCH_SURGERY_DATA } from "./index";

export const setSurgeryState = (payload) => {
  return {
    type: FETCH_SURGERY_DATA,
    payload: payload,
  };
};
